<template>
  <div>
    <el-form :model="knowledgePointsForm" :label-width="formWidth">
      <el-form-item label="知识点">
        <el-select multiple collapse-tags placeholder="请选择知识点" v-model="knowledgePointsForm.chapterKnowledgeList" style="width:100%">
          <el-option v-for="item in knowledgePointsList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
      <div class="knowledgePoints_footer">
        <el-button @click="$emit('knowledgePointsClose')">取 消</el-button>
        <el-button type="primary" @click="$emit('knowledgePointsSubmit',knowledgePointsForm,editBlock)">确 定</el-button>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    chapterForm: {
      id: 0,
      attachmentId: 0,
      materialsId: 0
    }
  },
  data() {
    return {
      formWidth: "60px",
      knowledgePointsForm: {
        chapterKnowledgeList: []
      },
      knowledgePointsList: [],
      editBlock: true
    };
  },
  methods: {
    getChapterKnowledgeByChapterId(){
      this.api.chapterMaterialsKnowledge.getChapterKnowledgeByChapterId({chapterId:this.chapterForm.id}).then(result=>{
        if(result.success){
          this.knowledgePointsList = result.data
        }else{
          this.$message.error(result.message)
        }
      })
    },


    getChapterMaterialsKnowledgeList(){
      let obj = {
        materialsId: this.chapterForm.materialsId,
        attachmentId: this.chapterForm.attachmentId
      }
      this.api.chapterMaterialsKnowledge.getChapterMaterialsKnowledgeList(obj).then(result=>{
        if(result.success){
          if(result.data.length == 0){
            this.editBlock = false
          }else{
            result.data.forEach(e => {
              this.knowledgePointsForm.chapterKnowledgeList.push(e.knowledgeId)
            });
          }
        }else{
          this.$message.error(result.message)
        }
      })
    }


  },
  watch: {
  },
  mounted() {
    this.getChapterMaterialsKnowledgeList();
    this.getChapterKnowledgeByChapterId();
  },
};
</script>
<style scoped>
.knowledgePoints_footer{
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/teachingResearch/components/knowledgePoints.vue